import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Dhuin`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0bed56b119efbccfce38116b91f7db10/d00b9/dhuin.webp",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAACQAwCdASoUAAsAPtFWpEuoJKOhsAgBABoJZwC/OBn4h67WCTfAAPQAQV+F2u1lups7Y0GSns0qL7qehJgozSYzTnhKEaVkAAA=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Film Poster",
            "title": "Film Poster",
            "src": "/static/0bed56b119efbccfce38116b91f7db10/d00b9/dhuin.webp",
            "srcSet": ["/static/0bed56b119efbccfce38116b91f7db10/c85cb/dhuin.webp 300w", "/static/0bed56b119efbccfce38116b91f7db10/e88ff/dhuin.webp 600w", "/static/0bed56b119efbccfce38116b91f7db10/d00b9/dhuin.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`A short film about an aspiring actor for Darbhanga planning to move to Mumbai. We see his family, friends and the local network of cinema fans, directors and actors that he is a part of. We see his ambitions, his insecurities and the fear he has.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      